import React from 'react';
import loadable from '@loadable/component';

/* @ts-expect-error type mismatch */
const Placeholder = ({ error }) => {
  if (error) {
    return <p>Cannot load wizard location</p>;
  }

  return <div />;
};

export default loadable(() => import('./WizardLocationSticky'), {
  fallback: Placeholder({
    /* @ts-expect-error type mismatch */
    pastDelay: true,
    error: false,
    timedOut: false,
  }),
});
